import type {Children} from 'interfaces';

interface IProps extends Children {
	title: string;
	subtitle: string;
}
const CardMetric: React.FC<IProps> = ({children, title, subtitle}) => (
	<div className="row mt-4">
		<div className="col-md-12">
			<div className="card-tasks card">
				<div className="card-header">
					<i className="bi bi-speedometer2 mr-3 float-left text-secundary bi-2" />
					<h2 className="card-title">{title}</h2>
					<p className="card-category">{subtitle}</p>
				</div>
				{children}
			</div>
		</div>
	</div>
);

export default CardMetric;
